import apiClient from "./api";

class CommunicationService {
  async getEmailTemplates(params = {}) {
    try {
      const response = await apiClient.get("/admin/templates/email/", {
        params,
      });
      // Handle paginated response
      const data = response.data;
      return {
        success: true,
        data: data.results || data,
        count: data.count || (Array.isArray(data) ? data.length : 0),
        next: data.next || null,
        previous: data.previous || null,
      };
    } catch (error) {
      console.error("Error fetching email templates:", error);
      return this.handleError(error);
    }
  }

  async getSmsTemplates(params = {}) {
    try {
      const response = await apiClient.get("/admin/templates/sms/", {
        params,
      });
      // Handle paginated response
      const data = response.data;
      return {
        success: true,
        data: data.results || data,
        count: data.count || (Array.isArray(data) ? data.length : 0),
        next: data.next || null,
        previous: data.previous || null,
      };
    } catch (error) {
      console.error("Error fetching SMS templates:", error);
      return this.handleError(error);
    }
  }

  // Get purposes for dropdown
  async getPurposes() {
    try {
      const response = await apiClient.get("/admin/templates/purposes/");
      const data = response.data;
      return {
        success: true,
        data: data.purposes || data.results || (Array.isArray(data) ? data : []),
      };
    } catch (error) {
      console.error("Error fetching purposes:", error);
      return this.handleError(error);
    }
  }

  // Get variables for dropdown
  // Get variables for dropdown
  async getVariables() {
    try {
      const response = await apiClient.get("/admin/templates/variables/");
      const data = response.data;
      return {
        success: true,
        data: data.variables || data.results || (Array.isArray(data) ? data : []),
      };
    } catch (error) {
      console.error("Error fetching variables:", error);
      return this.handleError(error);
    }
  }

  // Create email template
  async createEmailTemplate(payload) {
    try {
      const response = await apiClient.post("/admin/templates/email/", payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error creating email template:", error);
      return this.handleError(error);
    }
  }

  // Create SMS template
  async createSmsTemplate(payload) {
    try {
      const response = await apiClient.post("/admin/templates/sms/", payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error creating SMS template:", error);
      return this.handleError(error);
    }
  }

  // Update email template by purpose
  async updateEmailTemplate(purpose, payload) {
    try {
      const response = await apiClient.put(`/admin/templates/email/${purpose}/`, payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error updating email template:", error);
      return this.handleError(error);
    }
  }

  // Update SMS template by purpose
  async updateSmsTemplate(purpose, payload) {
    try {
      const response = await apiClient.put(`/admin/templates/sms/${purpose}/`, payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error updating SMS template:", error);
      return this.handleError(error);
    }
  }
  // Delete email template by purpose
  async deleteEmailTemplate(purpose) {
    try {
      const response = await apiClient.delete(`/admin/templates/email/${purpose}/`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error deleting email template:", error);
      return this.handleError(error);
    }
  }

  // Delete SMS template by purpose
  async deleteSmsTemplate(purpose) {
    try {
      const response = await apiClient.delete(`/admin/templates/sms/${purpose}/`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Error deleting SMS template:", error);
      return this.handleError(error);
    }
  }
  handleError(error) {
    let message = "An unexpected error occurred";

    if (error.response) {
      if (error.response.data) {
        if (typeof error.response.data === "string") {
          message = error.response.data;
        } else if (error.response.data.detail) {
          message = error.response.data.detail;
        } else if (error.response.data.error) {
          message = error.response.data.error;
        } else if (error.response.data.message) {
          message = error.response.data.message;
        } else {
          const firstKey = Object.keys(error.response.data)[0];
          if (firstKey && Array.isArray(error.response.data[firstKey])) {
            message = error.response.data[firstKey][0];
          }
        }
      }
    } else if (error.request) {
      message = "Unable to connect to server. Please check your connection.";
    }

    return {
      success: false,
      error: message,
    };
  }
}

export default new CommunicationService();
